import { useEffect, useState } from "react";

import useService from "../hooks/useService";

let cachedAnalytics;
let cachedPromise;

const useDashboardAnalytics = () => {
  const analyticsRepository = useService("repositories/dashboard-analytics-repository");

  const [analytics, setAnalytics] = useState();

  useEffect(() => {
    let isMounted = true;

    if (cachedAnalytics) {
      setAnalytics(cachedAnalytics);
      return () => {
        isMounted = false;
      };
    }

    if (!cachedPromise) {
      cachedPromise = analyticsRepository.query().then((response) => {
        cachedAnalytics = response;
        return response;
      });
    }

    cachedPromise
      .then((response) => {
        if (isMounted) {
          setAnalytics(response);
        }
      })
      .catch((error) => {
        console.error("Failed to fetch analytics", error);
        return error;
      });

    return () => {
      isMounted = false;
    };
  }, [analyticsRepository]);

  return analytics;
};

export default useDashboardAnalytics;
